import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


//prevent portal from being opened if it is already open in a different tab regardless of device. Provide user with the option to take over the session
const usePortalSession = (token, apiUrl) => {
  const navigate = useNavigate();
  let sessionId = sessionStorage.getItem("portal_session_id");

  if (!sessionId) {
    sessionId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("portal_session_id", sessionId);
  }

  useEffect(() => {
    const lockSession = async () => {
      if (!token) return;

      const res = await fetch(`${apiUrl}/api/portal_session/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          session_id: sessionId,
        }),
      });

      if (res.status === 409) {
        const takeover = window.confirm("This portal link is already open elsewhere. Close the other session?");
        if (!takeover) {
          navigate("/");
          return;
        }
        await fetch(`${apiUrl}/api/portal_session/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            session_id: sessionId,
            takeover: true,
          }),
        });
      }
    };
    lockSession();
  }, [token, apiUrl, navigate, sessionId]);
  return sessionId;
};

export default usePortalSession;